<template>
  <div class="dgs chat grid-gua paper-grain" data-product="heart">
    <div class="sheet">
      <div class="top">
        <div class="masthead">
          <div class="kicker">AI · 财 · 印 · 识人</div>
          <h1>AI 财印识人</h1>
          <div class="sub">上传聊天截图 · 让 AI 读懂对方的态度</div>
          <div class="rule"></div>
        </div>
      </div>

      <!-- 提出问题 -->
      <div class="card mt-4">
        <div class="card-title"><span class="dot"></span>提出问题</div>
        <van-form>
          <div class="field">
            <label>给这段聊天起个名字</label>
            <input class="control" type="text" v-model="name" placeholder="请输入名称">
          </div>
          <div class="field">
            <label>你想问什么</label>
            <textarea class="control ta" rows="3" v-model="prompt" placeholder="请输入提示词，例如：这个是这几天的聊天，她对我的态度是什么样的？"></textarea>
          </div>
          <div class="qchips">
            <span class="chip" @click="prompt = '她现在对我的好感度？'">她现在对我的好感度？</span>
            <span class="chip" @click="prompt = '她不回消息是什么意思？'">她不回消息是什么意思？</span>
            <span class="chip" @click="prompt = '我该不该主动联系她？'">我该不该主动联系她？</span>
          </div>
        </van-form>
      </div>

      <!-- 上传聊天截图 -->
      <div class="card mt-3">
        <div class="card-title"><span class="dot"></span>上传聊天截图</div>
        <div class="upload-area mt-3">
          <van-uploader
            v-model="fileList"
            multiple
            :max-count="5"
            :max-size="5 * 1024 * 1024"
            :after-read="afterRead"
            @oversize="onOversize"
            :before-delete="beforeDelete"
          />
        </div>
        <div class="up-note">最多 5 张 · 每张 ≤ 5M · 长图可以，但别太长</div>
      </div>

      <!-- 购买前请阅读 -->
      <div class="card mt-3">
        <div class="card-title"><span class="dot"></span>购买前请阅读</div>
        <div class="u-row"><span class="mark">壹</span><span>分析上传的聊天截图，回答对方对你的评价和态度。</span></div>
        <div class="u-row"><span class="mark">贰</span><span>通过云端大模型调用自有 skill 运行；个别情况下结果可能不尽如人意，继续追问即可获得客观答案。</span></div>
        <div class="u-row"><span class="mark">叁</span><span>第一次提问收费；同一聊天窗口内还有 4 次免费追问机会。第一次的提问质量决定后续回答质量，尽量一次问清楚。</span></div>
        <div class="u-row"><span class="mark">肆</span><span>生成需要时间，可以关窗口离开，之后在「查看记录」里获取结果。</span></div>
        <div class="u-row"><span class="mark">伍</span><span>名称请写得有辨识度；聊天截图不会长期保存。</span></div>
      </div>

      <div class="mt-4">
        <van-button
          :loading="loading"
          loading-text="请求中..."
          :disabled="!canSubmit"
          class="btn btn-seal btn-block"
          native-type="submit"
          @click="onSubmit"
        >开始分析</van-button>
        <p class="price-note">首次提问付费 · 同一窗口内 4 次免费追问</p>
        <van-button
          class="btn btn-ink btn-block mt-2"
          @click="gotoList"
        >查看记录</van-button>
      </div>

      <div class="foot">
        <img src="../assets/kefu.jpg" class="qr" alt="">
        <p>系统问题反馈 · 长按二维码添加微信</p>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast } from 'vant'
import { postAction, getAction } from '@/api/manage'
import wx from 'weixin-jsapi'
export default {
  name: 'ChatSubmit',
  data() {
    return {
      name: '',
      prompt: '',
      fileList: [],
      imageList: [],
      loading: false,
      pay: '0',
      userInfo: {},
    }
  },
  computed: {
    userinfoLove() {
      return this.$store.getters.getUserinfoLove || {}
    },
    openid() {
      return this.userinfoLove.jsopenid
    },
    unionid() {
      return this.userinfoLove.unionid
    },
    headimg() {
      return this.userinfoLove.image
    },
    nickname() {
      return this.userinfoLove.nickname
    },
    code() {
      return this.$route.query.code ? this.$route.query.code : ''
    },
    canSubmit() {
      // 必须至少有一张图片，且所有图片都上传完成
      if (this.fileList.length === 0) return false
      return !this.fileList.some(f => f.status === 'uploading')
    },
  },
  mounted() {
    // 本地调试：自动注入 mock 用户数据
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
      this.$store.commit('setUserInfoLove', {
        unionid: 'oni4R6b8pwMrPWp0DoctYi4-Wx4M',
        jsopenid: 'mock_openid_67890',
        nickname: '测试用户',
        image: ''
      })
      return
    }
    if (!this.unionid) {
      if (!this.code) {
        var url = encodeURIComponent(window.location.protocol + '//' + window.location.hostname + '/chatSubmit')
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxbb2af162829dc7fe&redirect_uri=${url}&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect`
      } else {
        this.getJsLogin()
      }
    }
  },
  methods: {
    getJsLogin() {
      const url = '/xcxlove/double/jslogin'
      postAction(url, { code: this.code }).then(res => {
        if (res.data.code == 200 || res.data.code == 400) {
          this.userInfo = res.data.msg
          this.$store.commit('setUserInfoLove', this.userInfo)
        }
      })
    },
      onOversize() {
        Toast.fail('图片大小不能超过5M')
      },
      afterRead(file) {
      // 支持多选时，file可能是数组
      const files = Array.isArray(file) ? file : [file]
      files.forEach(item => {
        item.status = 'uploading'
        item.message = '上传中...'
        let formData = new FormData()
        // 后端字段名为 pic，接口为 /pic/chat/upload，返回 filename 即文件名
         formData.append('pic', item.file)
         const url = '/pic/chat/upload'
         postAction(url, formData).then(res => {
           if (res.data.code == 200) {
             item.status = 'done'
             item.message = '上传完成'
             const fileName = res.data.msg
             item.url = fileName
             this.imageList.push(fileName)
           } else {
             item.status = 'failed'
             item.message = '上传失败'
             Toast.fail(res.data.msg || '上传失败')
           }
        }).catch(() => {
          item.status = 'failed'
          item.message = '上传失败'
        })
      })
    },
    beforeDelete(file, detail) {
      // 同步删除imageList中对应的文件名
      const fileName = this.getFileName(file.url)
      const idx = this.imageList.indexOf(fileName)
      if (idx > -1) {
        this.imageList.splice(idx, 1)
      }
      return true
    },
    getFileName(url) {
      // 从完整URL或路径中提取文件名
      if (!url) return ''
      return url.substring(url.lastIndexOf('/') + 1)
    },
    gotoList() {
      this.$router.push({ path: '/chatList' })
    },
    onSubmit() {
      if (!this.name) {
        Toast.fail('请输入名称')
        return
      }
      if (!this.prompt) {
        Toast.fail('请输入提示词')
        return
      }
      if (this.imageList.length === 0) {
        Toast.fail('请上传至少一张图片')
        return
      }
      // 校验是否所有图片都上传完成
      const uploading = this.fileList.some(f => f.status === 'uploading')
      if (uploading) {
        Toast.fail('图片正在上传中，请稍候')
        return
      }

      // 先调起微信支付
      Toast.loading({
        message: '正在评定中，请稍后...',
        forbidClick: true,
        duration: 0,
      })
      setTimeout(() => {
        Toast.clear()
        this.wxPay()
      }, 2000)
    },
    wxPay() {
      const url = '/chat/wxpay'
      var that = this
      getAction(url, {
        unionid: this.unionid,
        openid: this.openid
      }).then(res => {
        if (res.data.code === 200) {
          const result = res.data.msg.result
          wx.config({
            debug: false,
            appId: result.appId,
            timestamp: result.timeStamp,
            nonceStr: result.nonceStr,
            signature: result.paySign,
            jsApiList: ['checkJsApi', 'chooseWXPay']
          })
          wx.ready(() => {
            wx.checkJsApi({
              jsApiList: ['chooseWXPay'],
              success: function () {
                wx.chooseWXPay({
                  timestamp: result.timeStamp,
                  nonceStr: result.nonceStr,
                  package: result.package,
                  signType: result.signType,
                  paySign: result.paySign,
                  success: function () {
                    that.pay = '1'
                    that.analyze()
                  },
                  fail: function () {
                    Toast.fail('支付失败')
                  }
                })
              },
              fail: function (res) {
                console.log(res)
              }
            })
          })
          wx.error(err => {
            console.log(err)
          })
        } else {
          Toast.fail(res.data.msg)
        }
      }).catch(() => {
        Toast.fail('请求失败')
      })
    },
    analyze() {
      this.loading = true
      const url = '/chat/analyze'
      postAction(url, {
        unionid: this.unionid,
        pay: this.pay,
        name: this.name,
        prompt: this.prompt,
        image_list: this.imageList
      }).then(res => {
        if (res.data.code == 200) {
          Toast.success(res.data.msg || '提交成功')
          this.$router.push({ path: '/chatList' })
        } else {
          Toast.fail(res.data.msg)
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
<style scoped>
@import "../style/design-system.css";

.top { padding-top: 30px; }

/* 提问区 */
.qchips { display: flex; flex-wrap: wrap; gap: 8px; margin-top: 12px; }
.qchips .chip { cursor: pointer; }
.ta { resize: none; }

/* 上传区 */
.upload-area { margin-top: 14px; }
.up-note { margin-top: 10px; font-size: 12px; color: var(--ink-mute); }

/* 购买须知 */
.u-row { display: flex; gap: 8px; margin-top: 10px; font-size: 13px; color: var(--ink-soft); line-height: 1.6; text-align: left; }
.u-row .mark { color: var(--seal-dk); flex: none; width: 16px; font-family: var(--f-serif); }

.price-note { margin-top: 10px; font-size: 12px; color: var(--ink-mute); text-align: center; letter-spacing: .04em; }

/* 页脚二维码 */
.foot { margin-top: 30px; text-align: center; color: var(--ink-mute); font-size: 12px; letter-spacing: .08em; }
.foot .qr { display: block; width: 30%; margin: 0 auto 10px; }

/* Vant 组件样式覆盖 */
::v-deep .van-uploader__upload,
::v-deep .van-uploader__preview { border-radius: var(--r-m); }
::v-deep .van-uploader__upload { background: var(--paper-hi); border: 1.5px dashed rgba(27,25,22,.28); }
::v-deep .van-button { font-family: var(--f-sans); }
::v-deep .van-button--disabled { opacity: .5; }
</style>
